var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33386 31.111H36.6666V8.88916H3.33386V31.111ZM35.2778 29.7221H4.72273V10.278H35.2778V29.7221ZM6.45807 12.9608L20.0002 20.8009L33.5423 12.9608C33.8736 12.7691 33.9875 12.3441 33.7951 12.0122C33.6028 11.6809 33.1771 11.5663 32.8465 11.7594L20.0002 19.1968L7.15389 11.7594C6.82126 11.567 6.39696 11.6802 6.2053 12.0122C6.01294 12.3441 6.12613 12.7691 6.45807 12.9608Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.05d309082511ca44fbde40dba4872765.svg";
export { ForwardRef as ReactComponent };